<template>
  <div class="px-5 py-5">
    <div class="bg-white">
      <h2 class="font-bold text-center mb-5">Campaigns ({{campaignsData.total}})</h2>
      <div class="flex flex-col space-y-8">
        <div class="flex flex-row mx-auto w-full xl:w-1/2 flex-wrap">
          <label for="searchTerm" class="sr-only">Donation ID, Campaign ID, Name</label>
          <input type="text" v-model="searchTerm" v-on:keyup.enter="search" id="searchTerm" class="w-auto flex-1 sm:text-sm focus:outline-none focus:ring-pink-500 focus:border-pink-500" placeholder="Donation ID, Campaign ID, Name">

          <div class="flex mx-auto mt-3 xl:mt-0 xl:ml-3">
            <a @click="search"  href="#" class="inline-flex items-center justify-center px-5 py-3 border border-transparent text-base font-medium text-white bg-pink-500 hover:bg-pink-700 focus:outline-none  focus:ring-pink-200">
              Search
            </a>

            <div class="inline-flex shadow ml-3">
              <a @click="openFilterModal = true" href="#" class="inline-flex items-center justify-center px-5 py-3 border border-transparent text-base font-medium text-white bg-blue-500 hover:bg-blue-700 focus:outline-none  focus:ring-blue-200">
                Filter ({{this.filterCount}})
              </a>
            </div>
          </div>
        </div>
        <div class="mx-auto">
          <a href="#" @click="download" class="inline-flex items-center justify-center px-5 py-3 border border-transparent text-base font-medium text-white bg-green-500 hover:bg-green-700 focus:outline-none  focus:ring-green-200">
            Download Results
          </a>
        </div>


        <div class="xl:border border-gray-200">
          <div class="hidden xl:flex xl:flex-row px-6 py-3 bg-gray-50 text-left text-xs font-medium text-gray uppercase tracking-wider justify-between border-b border-gray-200">
            <div class="xl:w-1/12">&nbsp;</div>
            <div class="xl:w-1/12">ID</div>
            <div class="xl:w-5/12">Org Name</div>
            <div class="xl:w-1/12">Goal</div>
            <div class="xl:w-1/12">Total</div>
            <div class="xl:w-1/12">Event Date</div>
            <div class="xl:w-1/12">Created At</div>
            <div class="xl:w-1/12">&nbsp;</div>
          </div>
          <div class="flex flex-col space-y-3 xl:space-y-0">

            <div v-for="campaign in campaigns" class="flex flex-col xl:flex-row xl:px-6 xl:py-3 bg-white text-left text-sm text-gray justify-between items-center hover:bg-gray-100 border border-gray-200 xl:border-b xl:border-gray-50 xl:border-l-0 xl:border-t-0 xl:border-r-0 xl:items-start">

              <div class="flex flex-row w-full items-center xl:w-1/12 border-b border-gray-200 xl:border-0 bg-gray-100 xl:bg-transparent xl:text-base items-stretch">
                <div class="xl:hidden flex items-center justify-center xl:justify-start w-1/2 xl:w-full px-6 py-3 xl:px-0 xl:py-0 flex-1 text-center text-gray-500 font-medium">
                  Avatar
                </div>
                <div class="flex items-center justify-center xl:justify-start w-1/2 xl:w-full px-6 py-3 xl:px-0 xl:py-0 bg-gray-25 xl:bg-transparent text-gray-500 text-center">
                  <img class="w-10"  :src="campaign.thumbnail_logo ? campaign.thumbnail_logo : '/img/side-out-iconcircle.png'">
                </div>
              </div>

              <div class="flex flex-row w-full items-center xl:w-1/12 border-b border-gray-200 xl:border-0 bg-gray-100 xl:bg-transparent xl:text-base items-stretch">
                <div class="xl:hidden flex items-center justify-center xl:justify-start w-1/2 xl:w-full px-6 py-3 xl:px-0 xl:py-0 flex-1 text-center text-gray-500 font-medium">
                  ID
                </div>
                <div class="flex items-center justify-center xl:justify-start w-1/2 xl:w-full px-6 py-3 xl:px-0 xl:py-0 bg-gray-25 xl:bg-transparent text-gray-500 text-center xl:text-left">
                  {{ campaign.id }}
                </div>
              </div>

              <div class="flex flex-row w-full items-center xl:w-5/12 border-b border-gray-200 xl:border-0 bg-gray-100 xl:bg-transparent xl:text-base items-stretch">
                <div class="xl:hidden flex items-center justify-center xl:justify-start w-1/2 xl:w-full px-6 py-3 xl:px-0 xl:py-0 flex-1 text-center text-gray-500 font-medium">
                  Org Name
                </div>
                <div class="flex flex-col items-center xl:items-start justify-center xl:justify-start w-1/2 xl:w-full px-6 py-3 xl:px-0 xl:py-0 bg-gray-25 xl:bg-transparent text-gray-500 text-center xl:text-left">
                  <div>
                    {{ campaign.name }}

                    <div  v-if="campaign.user_id"  class="relative hidden xl:inline-flex">
                      <a v-tooltip="{ content: getContentCampaignUser(campaign)}">
                        <i class="fas fa-user text-blue ml-2 text-lg"></i>
                      </a>
                    </div>

                    <div  v-if="campaign.ownership == 'business' || campaign.ownership == 'school'"   class="relative hidden xl:inline-flex">
                      <a v-tooltip="{ content: getContentCampaignOwner(campaign)}">
                        <i class="fas fa-users text-base ml-2 text-x"></i>
                      </a>
                    </div>

                  </div>
                  <span v-html="getBreadcrumbs(campaign)"></span>
                </div>
              </div>

              <div class="flex flex-row w-full items-center xl:w-1/12 border-b border-gray-200 xl:border-0 bg-gray-100 xl:bg-transparent xl:text-base items-stretch">
                <div class="xl:hidden flex items-center justify-center xl:justify-start w-1/2 xl:w-full px-6 py-3 xl:px-0 xl:py-0 flex-1 text-center text-gray-500 font-medium">
                  Goal
                </div>
                <div class="flex items-center justify-center xl:justify-start w-1/2 xl:w-full px-6 py-3 xl:px-0 xl:py-0 bg-gray-25 xl:bg-transparent text-gray-500 text-center xl:text-left whitespace-nowrap">
                  $ {{ campaign.goal }}
                </div>
              </div>

              <div class="flex flex-row w-full items-center xl:w-1/12 border-b border-gray-200 xl:border-0 bg-gray-100 xl:bg-transparent xl:text-base items-stretch">
                <div class="xl:hidden flex items-center justify-center xl:justify-start w-1/2 xl:w-full px-6 py-3 xl:px-0 xl:py-0 flex-1 text-center text-gray-500 font-medium">
                  Total
                </div>
                <div class="flex items-center justify-center xl:justify-start w-1/2 xl:w-full px-6 py-3 xl:px-0 xl:py-0 bg-gray-25 xl:bg-transparent text-gray-500 text-center xl:text-left whitespace-nowrap">
                  $ {{ campaign.total_raised_directly_in_this_campaign }}
                </div>
              </div>

              <div class="flex flex-row w-full items-center xl:w-1/12 border-b border-gray-200 xl:border-0 bg-gray-100 xl:bg-transparent xl:text-base items-stretch">
                <div class="xl:hidden flex items-center justify-center xl:justify-start w-1/2 xl:w-full px-6 py-3 xl:px-0 xl:py-0 flex-1 text-center text-gray-500 font-medium">
                  Event Date
                </div>
                <div class="flex items-center justify-center xl:justify-start w-1/2 xl:w-full px-6 py-3 xl:px-0 xl:py-0 bg-gray-25 xl:bg-transparent text-gray-500 text-center xl:text-left">
                  {{ getEventDate(campaign) }}
                </div>
              </div>

              <div class="flex flex-row w-full items-center xl:w-1/12 border-b border-gray-200 xl:border-0 bg-gray-100 xl:bg-transparent xl:text-base items-stretch">
                <div class="xl:hidden flex items-center justify-center xl:justify-start w-1/2 xl:w-full px-6 py-3 xl:px-0 xl:py-0 flex-1 text-center text-gray-500 font-medium">
                  Created At
                </div>
                <div class="flex items-center justify-center xl:justify-start w-1/2 xl:w-full px-6 py-3 xl:px-0 xl:py-0 bg-gray-25 xl:bg-transparent text-gray-500 text-center xl:text-left">
                  {{ formatDate(campaign.created_at) }}
                </div>
              </div>

              <div class="flex flex-row w-full items-center xl:w-1/12 bg-gray-100 xl:bg-transparent justify-end xl:text-base items-stretch">
                <div class="xl:hidden flex items-center justify-center xl:justify-start w-1/2 xl:w-full px-6 py-3 xl:px-0 xl:py-0 flex-1 text-center text-gray-500 font-medium">
                  Actions
                </div>
                <div class="flex items-center justify-center xl:justify-start w-1/2 xl:w-auto px-6 py-3 xl:px-0 xl:py-0 bg-gray-25 xl:bg-transparent text-center text-gray-500">
                  <campaign-search-crud-button :user="user" :campaign="campaign" :key="campaign.id" ></campaign-search-crud-button>

                </div>
              </div>



            </div>

          </div>
        </div>

        <button v-if="this.next_page_url" @click="loadMore" type="button" id="loadMore" class="mx-auto items-center px-6 py-3 border border-transparent text-base font-medium shadow-sm text-white bg-green-500 hover:bg-green-700 focus:outline-none  focus:ring-green-200">
          Load More ({{campaignsData.to}} of {{campaignsData.total}})
        </button>



      </div>
    </div>

    <transition v-if="openFilterModal"
                enter-class="transition ease-out duration-100 transform"
                enter-active-class="opacity-0"
                enter-to-class="opacity-100"
                leave-class="transition ease-in duration-200 transform"
                leave-active-class="opacity-100"
                leave-to-class="opacity-0"
    >
    <div  class="fixed z-50 inset-0 overflow-y-auto"  id="campaign-search-modal">
      <div class="flex items-start justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">

        <div class="fixed inset-0 transition-opacity" aria-hidden="true">
          <div class="absolute inset-0 bg-gray-500 opacity-75"></div>
        </div>

        <!-- This element is to trick the browser into centering the modal contents. -->
        <span class="hidden sm:inline-block sm:align-middle sm:h-screen" aria-hidden="true">&#8203;</span>

        <div class="inline-block align-bottom bg-white rounded-lg px-4 pt-5 pb-4 text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle xl:max-w-lg w-full sm:p-6" role="dialog" aria-modal="true" aria-labelledby="modal-headline">
          <div class="sm:flex sm:items-start">
            <div class="text-center sm:mt-0 sm:text-left w-full">
              <div class="flex justify-between items-center pb-3">
                <h3 class="text-lg leading-6 font-medium text-gray-900" id="modal-headline">
                  Filter Results
                </h3>
                <div @click="openFilterModal = false" class="modal-close cursor-pointer z-50" id="close-campaign-modal">
                  <svg  class="fill-current text-black" xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18"><path d="M14.53 4.53l-1.06-1.06L9 7.94 4.53 3.47 3.47 4.53 7.94 9l-4.47 4.47 1.06 1.06L9 10.06l4.47 4.47 1.06-1.06L10.06 9z"></path></svg>
                </div>
              </div>
              <div class="my-3">
                <div class="sm:grid sm:grid-cols-3 sm:gap-4 sm:items-start sm:border-gray-200 sm:pt-5">
                  <label for="campaign_id" class="block text-sm font-medium text-gray-700 sm:mt-px sm:pt-2">
                    Campaign ID
                  </label>
                  <div class="mt-1 sm:mt-0 sm:col-span-2">
                    <input v-model="campaignId" type="text" name="campaign_id" id="campaign_id" autocomplete="" class="max-w-lg block w-full shadow-sm focus:outline-none focus:ring-pink-500 focus:border-pink-500 sm:max-w-xs sm:text-sm border-gray-300">
                  </div>
                </div>
                <!-- Date Picker -->
                <div class="sm:grid sm:grid-cols-3 sm:gap-4 sm:items-start sm:border-gray-200 sm:pt-5">
                  <label  class="block text-sm font-medium text-gray-700 sm:mt-px sm:pt-2">
                    Date
                  </label>
                  <div class="mt-1 sm:mt-0 sm:col-span-2">
<!--                    <input type="text" class="datetime-entry1" v-model="date">-->
                    <flat-pickr v-model="date" :config="{mode: 'range'}" class="max-w-lg block w-full shadow-sm focus:outline-none focus:ring-pink-500 focus:border-pink-500 sm:max-w-xs sm:text-sm border-gray-300"></flat-pickr>

                  </div>
                </div>
                <div class="sm:grid sm:grid-cols-3 sm:gap-4 sm:items-start sm:border-gray-200 sm:pt-5">
                  <label for="campaign_type" class="block text-sm font-medium text-gray-700 sm:mt-px sm:pt-2">
                    Campaign Type
                  </label>
                  <div class="mt-1 sm:mt-0 sm:col-span-2">
                    <select v-model="campaignType" id="campaign_type" name="campaign_type" autocomplete="" class="mt-1 block w-full py-2 px-3 border border-gray-300 bg-white shadow-sm focus:outline-none focus:ring-pink-500 focus:border-pink-500 sm:text-sm">
                      <option value=""></option>
                      <option value="1">Dig Pink</option>
                      <option value="2">Pledge Drive</option>
                      <option value="3">Standard</option>
                    </select>
                  </div>
                </div>

                <div class="sm:grid sm:grid-cols-3 sm:gap-4 sm:items-start sm:border-gray-200 sm:pt-5">
                  <label for="state" class="block text-sm font-medium text-gray-700 sm:mt-px sm:pt-2">
                    State
                  </label>
                  <div class="mt-1 sm:mt-0 sm:col-span-2">
                    <select id="state"  v-model="state" class="mt-1 block w-full py-2 px-3 border border-gray-300 bg-white shadow-sm focus:outline-none focus:ring-pink-500 focus:border-pink-500 sm:text-sm">
                      <option value=""></option>
                      <option value="AL">Alabama</option>
                      <option value="AK">Alaska</option>
                      <option value="AS">American Samoa</option>
                      <option value="AZ">Arizona</option>
                      <option value="AR">Arkansas</option>
                      <option value="CA">California</option>
                      <option value="CO">Colorado</option>
                      <option value="CT">Connecticut</option>
                      <option value="DE">Delaware</option>
                      <option value="DC">District of Columbia</option>
                      <option value="FM">Federated States of Micronesia</option>
                      <option value="FL">Florida</option>
                      <option value="GA">Georgia</option>
                      <option value="GU">Guam</option>
                      <option value="HI">Hawaii</option>
                      <option value="ID">Idaho</option>
                      <option value="IL">Illinois</option>
                      <option value="IN">Indiana</option>
                      <option value="IA">Iowa</option>
                      <option value="KS">Kansas</option>
                      <option value="KY">Kentucky</option>
                      <option value="LA">Louisiana</option>
                      <option value="ME">Maine</option>
                      <option value="MH">Marshall Islands</option>
                      <option value="MD">Maryland</option>
                      <option value="MA">Massachusetts</option>
                      <option value="MI">Michigan</option>
                      <option value="MN">Minnesota</option>
                      <option value="MS">Mississippi</option>
                      <option value="MO">Missouri</option>
                      <option value="MT">Montana</option>
                      <option value="NE">Nebraska</option>
                      <option value="NV">Nevada</option>
                      <option value="NH">New Hampshire</option>
                      <option value="NJ">New Jersey</option>
                      <option value="NM">New Mexico</option>
                      <option value="NY">New York</option>
                      <option value="NC">North Carolina</option>
                      <option value="ND">North Dakota</option>
                      <option value="MP">Northern Mariana Islands</option>
                      <option value="OH" selected="selected">Ohio</option>
                      <option value="OK">Oklahoma</option>
                      <option value="OR">Oregon</option>
                      <option value="PW">Palau</option>
                      <option value="PA">Pennsylvania</option>
                      <option value="PR">Puerto Rico</option>
                      <option value="RI">Rhode Island</option>
                      <option value="SC">South Carolina</option>
                      <option value="SD">South Dakota</option>
                      <option value="TN">Tennessee</option>
                      <option value="TX">Texas</option>
                      <option value="UT">Utah</option>
                      <option value="VT">Vermont</option>
                      <option value="VI">Virgin Islands</option>
                      <option value="VA">Virginia</option>
                      <option value="WA">Washington</option>
                      <option value="WV">West Virginia</option>
                      <option value="WI">Wisconsin</option>
                      <option value="WY">Wyoming</option>
                    </select>
                  </div>
                </div>
                <div class="sm:grid sm:grid-cols-3 sm:gap-4 sm:items-start sm:border-gray-200 sm:pt-5">
                  <label for="amount" class="block text-sm font-medium text-gray-700 sm:mt-px sm:pt-2">
                    Total Raised ($)
                  </label>
                  <div class="mt-1 sm:mt-0 sm:col-span-2">
                    <input v-model="totalRaised" type="text" name="amount" id="amount" autocomplete="" class="max-w-lg block w-full shadow-sm focus:outline-none focus:ring-pink-500 focus:border-pink-500 sm:max-w-xs sm:text-sm border-gray-300">
                  </div>
                </div>

                <div class="sm:grid sm:grid-cols-3 sm:gap-4 sm:items-start sm:border-gray-200 sm:pt-5">
                  <div class="block text-sm font-medium text-gray-700 sm:mt-px sm:pt-2">
                    &nbsp;
                  </div>
                  <div class="mt-1 sm:mt-0 sm:col-span-2">
                    <div class="relative flex">
                      <div class="flex items-center h-5">
                        <input v-model="doNotShowSubCampaign" type="checkbox" class="focus:ring-0 h-4 w-4 text-pink border-gray-300 rounded">
                      </div>
                      <div class="ml-3 text-sm">
                        <label  class="font-medium text-gray-700 font-bold">Only show top-level campaign</label>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Date Picker -->


              </div>
            </div>
          </div>
          <div class="mt-5 sm:mt-4 sm:flex sm:flex-row-reverse">
            <button @click="resetFilters" class="w-full inline-flex justify-center border border-transparent shadow-sm px-4 py-2 bg-pink-500 text-base font-medium text-white hover:bg-pink-700 focus:outline-none  focus:ring-offset-2 focus:ring-pink-500 sm:ml-3 sm:w-auto sm:text-sm">
              Reset
            </button>
            <button @click="search"  class="mt-3 w-full inline-flex justify-center border border-blue-500 shadow-sm px-4 py-2 bg-blue-500 text-base font-medium text-white hover:bg-blue-700 focus:outline-none  focus:ring-offset-2 focus:ring-blue-500 sm:mt-0 sm:w-auto sm:text-sm">
              Filter
            </button>
          </div>
        </div>
      </div>
    </div>

    </transition>

    <div v-if="isExporting || showExportModal" class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div class="bg-white p-6 rounded-lg shadow-lg w-96">
        <div class="flex justify-between items-center mb-4">
          <h3 class="text-lg font-semibold">{{ exportStatus }}</h3>
          <button @click="hideExportModal" class="text-gray-500 hover:text-gray-700">
            <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>
        <div class="w-full bg-gray-200 rounded-full h-2.5 dark:bg-gray-700 mb-4">
          <div class="bg-blue-600 h-2.5 rounded-full" :style="{ width: exportProgress + '%' }"></div>
        </div>
        <p class="text-sm text-gray-600">{{ exportMessage }}</p>
      </div>
    </div>

  </div>
</template>

<script>
  import moment from "moment";
  import flatPickr from 'vue-flatpickr-component';
  import VueScrollTo from 'vue-scrollto';

  export default {
    props: {
      allCampaigns: {},
      user: {},
    },
    components: {
      flatPickr
    },
    data() {
      return {
        options: {
          classes: ''
        },
        campaignsData: this.allCampaigns,
        campaigns: this.allCampaigns?.data,
        isOpen: false,
        openFilterModal: false,

        next_page_url: this.allCampaigns?.next_page_url ?  '/campaign-search-with-term?page=2' : '',
        searchTerm: '',
        doNotShowSubCampaign: 0,
        totalRaised: '',
        state: '',
        campaignType: '',
        campaignId: '',
        date: '',
        filterCount: 0,
        isExporting: false,
        showExportModal: false,
        exportStatus: '',
        exportProgress: 0,
        exportMessage: '',
        exportCheckInterval: null,
      }
    },
    methods: {
      getBreadcrumbs(campaign) {
        // Debug log the raw breadcrumbs
        console.log('Raw breadcrumbs for campaign ' + campaign.id + ':', campaign.breadcrumbs);
        
        let breadcrumbLinks = [];
        
        // Validate breadcrumbs exists
        if (!campaign.breadcrumbs) {
          console.warn('No breadcrumbs found for campaign:', campaign.id);
          return '';
        }

        // Safely parse JSON with error handling
        let breadcrumbs;
        try {
          breadcrumbs = JSON.parse(campaign.breadcrumbs);
          console.log('Parsed breadcrumbs:', breadcrumbs);
        } catch (e) {
          console.error('Failed to parse breadcrumbs for campaign ' + campaign.id + ':', e);
          return '';
        }

        // Ensure breadcrumbs is not null/undefined after parsing
        if (!breadcrumbs) {
          console.warn('Parsed breadcrumbs is null/undefined for campaign:', campaign.id);
          return '';
        }
        
        // Handle array format
        if (Array.isArray(breadcrumbs)) {
          console.log('Processing breadcrumbs as array');
          // Sort by array index to ensure order
          breadcrumbs.forEach((value, index) => {
            if (value?.id != campaign.id) {
              console.log(`Adding breadcrumb at index ${index}:`, value);
              breadcrumbLinks.push("<a target='_blank' class='text-pink hover:text-gray text-xs mt-2' href='/campaigns/"+value?.id+"'>"+value?.name+"</a>");
            }
          });
        } else if (typeof breadcrumbs === 'object') {
          console.log('Processing breadcrumbs as object');
          // If it's an object, try to maintain order by keys
          const orderedKeys = Object.keys(breadcrumbs).sort();
          orderedKeys.forEach(key => {
            const value = breadcrumbs[key];
            if (value?.id != campaign.id) {
              console.log(`Adding breadcrumb for key ${key}:`, value);
              breadcrumbLinks.push("<a target='_blank' class='text-pink hover:text-gray text-xs mt-2' href='/campaigns/"+value?.id+"'>"+value?.name+"</a>");
            }
          });
        } else {
          console.warn('Unexpected breadcrumbs format for campaign ' + campaign.id + ':', typeof breadcrumbs);
          return '';
        }
        
        const result = _.join(breadcrumbLinks, ' / ');
        console.log('Final breadcrumbs HTML for campaign ' + campaign.id + ':', result);
        return result;
      },
      formatDate(date) {
        return moment(date).format('MM-DD-YYYY')
      },
      getFilterRequestQuery() {
        this.filterCount = 0

        let query = ''
        if (this.doNotShowSubCampaign == 1) {
          query = query + '&doNotShowSubCampaign='+1
          this.filterCount++
        }
        if (this.totalRaised ) {
          query = query + '&totalRaised='+this.totalRaised
          this.filterCount++
        }
        if (this.state ) {
          query = query + '&state='+this.state
          this.filterCount++
        }
        if (this.campaignType ) {
          query = query + '&campaignType='+this.campaignType
          this.filterCount++
        }
        if (this.campaignId ) {
          query = query + '&campaignId='+this.campaignId
          this.filterCount++
        }
        if (this.date ) {
          query = query + '&date='+this.date
          this.filterCount++
        }
        return query
      },
      resetFilters() {
        this.doNotShowSubCampaign = ''
        this.totalRaised =  ''
        this.state =  ''
        this.campaignType =  ''
        this.campaignId =  ''
        this.date = null
      },
      search() {
        axios.get('/campaign-search-with-term?search_term='+this.searchTerm+this.getFilterRequestQuery())
            .then(response => {
              this.campaigns =   response.data.data
              this.campaignsData =   response.data
              this.next_page_url = response.data.next_page_url
              this.isLoading = false
              this.isLoadingMore = false

              this.openFilterModal = false
            })
      },
      loadMore() {
        if (this.next_page_url) {
          axios.get(this.next_page_url+'&search_term='+this.searchTerm)
              .then(response => {
                this.campaignsData =   response.data

                response.data.data.map((value, key) => {
                  this.campaigns.push(value)
                })
                this.next_page_url = response.data.next_page_url
                this.isLoading = false
                this.isLoadingMore = false

                if (this.next_page_url) {
                  VueScrollTo.scrollTo('#loadMore', {
                    duration: 1500,
                    offset: -100
                  })
                }
              })
        } else {
          this.isLoading = false
          this.isLoadingMore = false
        }
      },
      ownershipName(campaign) {
        if (campaign.ownership == 'business') {
          return 'Business'
        }
        return 'School'
      },
      download() {
        this.isExporting = true;
        this.showExportModal = true;
        this.exportStatus = 'Starting export...';
        this.exportProgress = 0;

        axios.post('/campaign-search-export?search_term='+this.searchTerm+this.getFilterRequestQuery(), {
          file_name: 'campaigns-export.xlsx'
        }).then((response) => {
          this.checkExportStatus();
        }).catch((error) => {
          this.isExporting = false;
          this.exportStatus = 'Export failed. Please try again.';
        });
      },

      hideExportModal() {
        this.showExportModal = false;
        this.exportProgress = 0;
        this.exportMessage = '';
        this.exportStatus = '';
        if (this.isExporting) {
          this.isExporting = false;
        }
        if (this.exportCheckInterval) {
          clearInterval(this.exportCheckInterval);
          this.exportCheckInterval = null;
        }
      },

      checkExportStatus() {
        if (!this.exportCheckInterval) {
          this.exportCheckInterval = setInterval(() => {
            axios.get('/campaign-export-status').then((response) => {
              if (response.data.status === 'completed') {
                this.isExporting = false;
                this.exportStatus = 'Export completed!';
                this.exportProgress = 100;
                window.location.href = response.data.download_url;
                setTimeout(() => {
                  this.hideExportModal();
                }, 2000);
              } else if (response.data.status === 'pending' || response.data.status === 'queued') {
                this.exportStatus = response.data.message || 'Processing...';
                this.exportProgress = response.data.progress || 0;
              } else {
                clearInterval(this.exportCheckInterval);
                this.exportCheckInterval = null;
                this.isExporting = false;
                this.exportStatus = 'Export failed';
                this.exportProgress = 0;
              }
            }).catch((error) => {
              clearInterval(this.exportCheckInterval);
              this.exportCheckInterval = null;
              this.isExporting = false;
              this.exportStatus = 'Export failed';
              this.exportProgress = 0;
            });
          }, 2000);
        }
      },

      getContentCampaignUser(campaign) {
        return campaign.user_name + ' ('+ campaign.email+')'
      },
      getContentCampaignOwner(campaign) {
        return campaign.business_name + ' ('+ campaign.city+', '+campaign.state+')'
      },
      getEventDate(campaign) {
        let metaData = campaign.meta_data

        if (metaData) {
          let data = JSON.parse(metaData)
          if (data.event_date) {
            return this.formatDate(data.event_date)
          }
        }
        if (campaign.event_date) {
          return this.formatDate(campaign.event_date)
        }
        return null
      },

    }
  }
</script>

<style scoped>

</style>
